<template>
  <div>
    <div class="breadcrumb">
      <ul>
        <li v-for="(bc, i) in breadcrumbs" :key="i" :class="{'linked': !!bc.link}">
          <router-link tag="li" :to="bc.link">
            <div v-if="i === product.breadcrumbs.length -1">
              <a style="text-decoration: none; color: black; font-weight: bold;">{{bc.name}}</a>
            </div>
            <a v-else style="text-decoration: none; color: black;">{{bc.name}}</a>
          </router-link>
        </li>
      </ul>
    </div>
    <v-container text-xs-center style="background-color: transparent">
      <v-layout row wrap>
        <v-flex sm2 hidden-xs-only>
          <v-btn
            v-for="(type, idx) in types"
            :key="idx"
            block
            flat
            class="btn-white-security text-14-security"
            @click="goToProductList(type)"
            :id="type"
          >{{ type }}</v-btn>
          <v-btn
            class="btn-white-security text-14-security mt-5"
            flat
            block
            to="/perfil/mis-avisos"
            :style="this.$route.name == 'my-products' ? 'background: #789c4a !important; border-color: #789c4a !important; color: white; font-weight: 700;': '' "
          >Mis Anuncios</v-btn>
        </v-flex>
        <v-flex xs12 md10 pl-4>
          <v-card>
            <v-layout pa-4 row wrap>
              <v-flex xs12 md8>
                <lingallery :items="product.items" responsive />
              </v-flex>
              <v-flex xs12 md4>
                <v-layout row wrap>
                  <v-flex xs12 sm12 class="text-xs-left">
                    <div
                      class="text-25-security font-weight-bold grey-security text-uppercase"
                    >{{product.name}}</div>
                    <div
                      class="text-25-security font-weight-bold green-security"
                    >{{ product.currency }} {{formatPrice(product.price)}}</div>
                    <b>Publicado por:</b>
                    {{product.user_full_name}}
                    <br />
                    <b>Empresa:</b>
                    {{product.user_company}}
                    <br />
                    <b>Ubicación:</b>
                    {{product.location}}
                    <br />
                    <b v-if="product.published_date">Fecha de publicación:</b>
                    {{product.published_date}}
                    <br />
                  </v-flex>
                  <v-flex xs12 text-md-left pt-4>
                    <v-btn
                      class="btn-security white--text"
                      style="background-color: rgb(33, 22, 81);"
                      :href="`mailto: ${product.email}?subject=[Contacto Anuncio] ${product.name}`"
                    >Contactar</v-btn>
                  </v-flex>
                  <v-flex v-if="!product.approved" pt-4>
                    <v-card color="grey darken-2">
                      <h2 class="white--text">Aviso en proceso de aprobación</h2>
                    </v-card>
                  </v-flex>
                  <v-flex v-if="product.user_id === current_user.id && product.is_expired && product.approved">
                    <v-card color="white" class="elevation-20">
                      <h1 class="red--text">Aviso caducado</h1>
                      <p>Si desea volver a habilitar su aviso, presione en Reactivar</p>
                      <v-btn color="green" class="white--text headline" @click="update">Reactivar</v-btn>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-4>
                <div class="text-justify text-16-security grey-security">{{product.description}}</div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-btn color="info" @click="goToProductList">Avisos clasificados</v-btn>
      <v-btn
        color="info"
        @click="goToMyProductList"
        v-if="product.user_id === current_user.id"
      >Volver a mis avisos</v-btn>
      <v-btn
        color="red darken-2"
        class="white--text"
        @click="this.delete"
        v-if="product.user_id === current_user.id"
      >Eliminar</v-btn>
      <v-btn
        v-if="this.current_user.role == 'admin' || product.user_id === current_user.id"
        color="warning"
        @click="goToProductEdit(product.id)"
        target="_blank"
      >Editar</v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      types: ["todos", "autos", "propiedades", "servicios", "varios"]
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapGetters("products", ["getTypes"]),
    breadcrumbs() {
      return this.$vuetify.breakpoint.smAndDown ? this.product.breadcrumbs.slice(0, 2) : this.product.breadcrumbs 
    }
  },
  methods: {
    ...mapMutations("product", ["setProduct"]),
    ...mapActions({
      updateProductExpiration: "products/updateProductExpiration",
      removeProduct: "products/removeProduct"
    }),
    update() {
      Swal.fire({ title: "Estamos cargando su petición..." });
      Swal.showLoading();
      this.updateProductExpiration(this.product).then(() => {
        this.$router.push({ name: "my-products" });
        Swal.fire({
          title: "¡Reactivación exitosa!",
          text: "El anuncio está visible para todos nuevamente.",
          type: "success",
          confirmButtonText: "Ok"
        });
      });
    },
    delete() {
      Swal.fire({
        title: "¿Estás segur@?",
        text: "¡Esta acción no se puede revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!"
      }).then(result => {
        if (result.value) {
          Swal.showLoading();
          this.removeProduct(this.product.id);
          Swal.fire(
            "¡Eliminado!",
            "Tu publicación ha sido eliminada.",
            "success"
          );
          this.$router.push({ name: "my-products" });
        }
      });
    },
    goToProductList(category) {
      this.$router.push({
        name: "products",
        params: { category: category}
      });
    },
    goToMyProductList() {
      this.$router.push({
        name: "my-products"
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToProductEdit(id){
      this.$router.push({
        name: "product-edit",
        params: { id: id }
      });
    }
  }
};
</script>

<style scoped>
.image_style {
  border: 1px solid lightgray;
  padding: 10px;
}
ul {
  display: flex;
  justify-content: left;
  list-style-type: none;
}
ul > li {
  display: flex;
  float: left;
  width: auto;
  color: default;
  font-weight: bold;
  font-size: 1.2em;
  cursor: default;
  align-items: center;
}
ul > li:not(:last-child)::after {
  content: ">";
  float: right;
  font-size: 1.2em;
  margin: 0 0.5em;
  color: light-default;
  cursor: default;
}
.linked {
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}
</style>

